import { PasswordRecoveryPageContent } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const PasswordRecoveryPage = () => {
  return (
    <PageProvider>
      <PasswordRecoveryPageContent />
    </PageProvider>
  );
};
